export default {
  Text: 'ai.msg.domain.responses.core.Text',
  Video: 'ai.msg.domain.responses.core.Video',
  Image: 'ai.msg.domain.responses.core.Image',
  Card: 'ai.msg.domain.responses.core.Card',
  Carousel: 'ai.msg.domain.responses.core.Carousel',
  MessageInfoAttachment: 'ai.msg.domain.responses.core.MessageInfoAttachment',
  File: 'ai.msg.domain.responses.core.GenericFileAttachment',
  ANSWER_NET_MULTI_SOURCE: 'ANSWER_NET_MULTI_SOURCE',
  NBA_RESPONSE: 'NBA_RESPONSE',
  EMAIL: 'ai.msg.domain.responses.core.Email'
}
